import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { IconsMockApi } from './ui/icons/api';

export const mockApiServices = [
    NavigationMockApi,
    IconsMockApi
];
